import { observable } from "mobx";
import { GET } from "Common/api";
import config from "lib/config";
import _ from "lodash";

const CacheKey = "selectedUnit";
const unitChangeEvent = new CustomEvent("unitChange");

class ManagerUnitsStore {
  @observable ready = false;
  @observable active = undefined;
  @observable list = [];

  constructor() {
    this.active =
      luvit.GetQueryString("unitid") ||
      luvit.GetQueryString("u") ||
      sessionStorage[CacheKey] ||
      config.defaultUnitId;
  }

  async reload(opts) {
    let load = (opts && opts.force) || !this.ready;
    let list = this.list || [];
    if (load) {
      list = await GET(
        "/v1/talentmanagement/manager/dashboard/available-units",
      );

      _.each(list, (l) => (l.depth = l.tree.replace(/[^\.]/g, "").length - 2)); // -2 = remove self and root node from depth
      this.list = list = _.sortBy(list, "tree");
    }

    this.ready = true;
    this.active =
      this.active === undefined
        ? list.length > 0
          ? list[0].id
          : undefined
        : this.active;
  }

  async activateUnit(opts) {
    if (_.isNumber(opts)) opts = { selectedUnit: opts };

    if (opts.triggerChangeEvent !== false) {
      setTimeout(() => window.dispatchEvent(unitChangeEvent), 1);
    }
    this.active = opts.selectedUnit;
  }
}

export default new ManagerUnitsStore();
